import store from '@/store'
import router from '@/router'

router.beforeEach((to, from, next) => {
  if (!to.matched.some(r => r.meta.noCloseDialogs)) {
    store.commit('dialogs/resetDialogs')
  }
  next()
})
